import client from './client';

/** Fire a global event so badges/bars refresh instantly without polling. */
function notifyCartChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('cart:changed'));
  }
}

export interface CartItem {
  id: number;
  cart_id: number;
  product_id: number;
  quantity: number;
  price_at_add: number;
  created_at: string;
  updated_at: string;
}

export interface Cart {
  id: number;
  customer_id: number;
  store_id: number;
  items: CartItem[];
  created_at: string;
  updated_at: string;
}

export interface AddToCartRequest {
  store_id: number;
  product_id: number;
  quantity: number;
}

export interface CartSummary {
  item_count: number;
  total: number;
  store_count: number;
  stores: Array<{
    store_id: number;
    store_name: string;
    item_count: number;
    subtotal: number;
  }>;
}

export const cartAPI = {
  async getSummary(): Promise<CartSummary> {
    const { data } = await client.get<CartSummary>('/api/cart/summary');
    return data;
  },

  async getCart(storeId: number): Promise<Cart> {
    const { data } = await client.get<Cart>(`/api/cart/${storeId}`);
    return data;
  },

  async addToCart(
    storeId: number,
    productId: number,
    quantity: number
  ): Promise<CartItem> {
    const { data } = await client.post<CartItem>(
      `/api/cart/add?store_id=${storeId}&product_id=${productId}&quantity=${quantity}`
    );
    notifyCartChanged();
    return data;
  },

  async updateCartItem(cartItemId: number, quantity: number): Promise<CartItem> {
    const { data } = await client.put<CartItem>(
      `/api/cart/item/${cartItemId}?quantity=${quantity}`
    );
    notifyCartChanged();
    return data;
  },

  async removeFromCart(cartItemId: number): Promise<any> {
    const { data } = await client.delete(`/api/cart/item/${cartItemId}`);
    notifyCartChanged();
    return data;
  },

  async clearCart(storeId: number): Promise<any> {
    const { data } = await client.delete(`/api/cart/${storeId}`);
    notifyCartChanged();
    return data;
  },

  async getCartTotal(storeId: number): Promise<{ total: number; item_count: number }> {
    const { data } = await client.get<{ total: number; item_count: number }>(
      `/api/cart/${storeId}/total`
    );
    return data;
  },
};
